'use client'

import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '@/lib/utils'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

/**
 * The popover surface's look, on its own so imperative DOM (the EdgeScript editor's
 * signature tooltip lives inside CodeMirror, not React) can wear the same surface.
 */
export const popoverContentClassName =
  'rounded-md border border-primary/15 bg-popover p-4 text-popover-foreground shadow-2xl shadow-black/40 outline-hidden'

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, forceMount, onWheel, ...props }, ref) => (
  <PopoverPrimitive.Portal forceMount={forceMount}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      forceMount={forceMount}
      // Stop wheel bubbling so react-remove-scroll's document-level listener
      // (installed by any ancestor Radix Dialog/Sheet) doesn't preventDefault
      // the scroll on this portaled content.
      onWheel={(e) => {
        e.stopPropagation()
        onWheel?.(e)
      }}
      className={cn(
        popoverContentClassName,
        'z-50 w-72 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-popover-content-transform-origin)',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
